<template>
  <v-card>
    <v-card-title class="bt-card-title">
      <!-- User logged -->
      <template v-if="signSteps.logged">
        <InfosLogged />
        <br />
        <next-step :enabled="signSteps.logged" :resetPaymentOptions="true"/>
        <v-btn
          block
          outline
          round
          class="normal-text"
          color="primary"
          @click="anotherUser"
        >Não sou eu, utilizar outro email</v-btn>
      </template>

      <!-- User trying to sign in -->
      <template v-if="signSteps.signForm">
        <InfosSignin v-if="signSteps.step < 2 || signSteps.step > 4" />
        <InfosForgotPassword v-if="signSteps.step > 1 && signSteps.step < 4" />
        <!-- <InfosSignup v-if="signSteps.step == 4" /> -->
      </template>
    </v-card-title>

    <!-- <infos-options /> -->
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import jwtDecode from 'jwt-decode';
// import InfosOptions from './InfosOptions';
import InfosLogged from './forms/InfosLogged';
import InfosSignin from './forms/InfosSignin';
import InfosForgotPassword from './forms/InfosForgotPassword';
// import InfosSignup from './forms/InfosSignup';
import NextStep from '../UI/NextStepButton';

export default {
  components: {
    // InfosOptions,
    InfosLogged,
    InfosSignin,
    InfosForgotPassword,
    // InfosSignup,
    NextStep,
  },
  computed: {
    ...mapGetters({
      clientToken: 'clientToken',
      userProps: 'userProps',
      signSteps: 'signSteps',
    }),
  },
  methods: {
    ...mapActions({
      eraseClientToken: 'eraseClientToken',
      setSignSteps: 'setSignSteps',
      setUserProps: 'setUserProps',
    }),
    userLogged() {
      return this.clientToken ? jwtDecode(this.clientToken) : null;
    },
    anotherUser() {
      this.setUserProps({
        clientID: null,
        email: '',
        name: '',
        lastname: '',
        ddi: '55',
        country: '',
        notBrazillian: false,
        document: '',
        phone: '',
        ddd: '',
        password: '',
      });
      this.setSignSteps({ logged: false, signForm: true, step: 0 });
      this.eraseClientToken();
      // deslogando
      this.$store.dispatch('sendPostMessage', {
        login: false,
        logout: true
      });
    },
  },
};
</script>
